function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5123",
  "data-name": "Group 5123",
  transform: "translate(838.957 1439.79)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3421",
  "data-name": "Path 3421",
  className: "cls-2",
  d: "m641.524 375.2 2.361-1.46.461-.286h7.665a4.772 4.772 0 0 0 4.766-4.767v-3.812a4.773 4.773 0 0 0-4.766-4.767h-5.721a4.773 4.773 0 0 0-4.767 4.767V375.2m-1.907 3.421v-13.743a6.673 6.673 0 0 1 6.673-6.674h5.721a6.673 6.673 0 0 1 6.672 6.674v3.812a6.672 6.672 0 0 1-6.672 6.673h-7.123z",
  transform: "translate(68.893 -1052.204)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3422",
  "data-name": "Path 3422",
  className: "cls-2",
  d: "M653.17 366.2h-6.554a1 1 0 0 1 0-2h6.554a1 1 0 0 1 0 2z",
  transform: "translate(68.363 -1052.204)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3423",
  "data-name": "Path 3423",
  className: "cls-2",
  d: "M649.616 370.2h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z",
  transform: "translate(68.363 -1052.204)"
}));

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_7453",
    "data-name": "Group 7453",
    transform: "translate(-1534 -733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(1534 733)",
    style: {
      fill: "#ebf3f5",
      opacity: 0.25
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.b4150352.svg";
export { ForwardRef as ReactComponent };